import "./CurrentLocation.css";

function CurrentLocation({
  providerData,
  setProviderData,
}) {

  const getCurrentLocation = () => {
  if (!navigator.geolocation) {
    alert("Geolocation is not supported by your browser.");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;

      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
        );

        const data = await response.json();

        const address = data.address || {};

        setProviderData({
          ...providerData,
          address: {
            ...providerData.address,

            latitude,
            longitude,

            doorNo: "",

            street:
              address.road ||
              address.pedestrian ||
              address.street ||
              "",

            landmark:
              address.neighbourhood ||
              address.suburb ||
              "",

            area:
              address.suburb ||
              address.city_district ||
              address.neighbourhood ||
              "",

            city:
              address.city ||
              address.town ||
              address.village ||
              "",

            state: address.state || "",

            pincode: address.postcode || "",
          },
        });

        alert("Current location captured successfully.");
      } catch (err) {
        console.log(err);
        alert("Unable to fetch address.");
      }
    },
    (error) => {
      console.log(error);
      alert("Unable to fetch your current location.");
    }
  );
};
    

  return (

    <div className="current-location">

      <button
        type="button"
        className="location-btn"
        onClick={getCurrentLocation}
      >

        📍 Use Current Location

      </button>

      {

        providerData.address?.latitude &&

        <div className="location-info">

          <p>

            <strong>Latitude:</strong>{" "}

            {providerData.address.latitude}

          </p>

          <p>

            <strong>Longitude:</strong>{" "}

            {providerData.address.longitude}

          </p>

        </div>

      }

    </div>

  );

}

export default CurrentLocation;